import { ACH_ACCOUNT_TYPE, AMOUNT_TYPES, DEFAULT_AUTOPAY_TIMING, PAYMENT_METHODS } from 'settings/constants/payment'

const { CREDIT_CARD } = PAYMENT_METHODS
const { CURRENT_AMOUNT_DUE, OTHER_AMOUNT } = AMOUNT_TYPES

const METHOD_MODEL = {
  accountToken: null,
  expiry: null,
  cardHolderName: '',
  cvv: '',
  accountType: ACH_ACCOUNT_TYPE[0],
  cardNickName: '',
  defaultAccount: false,
  autoPay: false,
  autoPayTime: DEFAULT_AUTOPAY_TIMING,
  type: CREDIT_CARD,
}

const MAKE_PAYMENT_MODEL = {
  ...METHOD_MODEL,
  amountDueOption: CURRENT_AMOUNT_DUE,
  otherAmount: '',
  selectedPaymentMethodId: '',
  selectedPaymentMethod: null,
  showOtherPayment: false,
  transactionRef: null,
}

export { METHOD_MODEL, MAKE_PAYMENT_MODEL }
